export default "__VITE_ASSET__BhM83qgn__"